import {
    DashboardWidgetModel,
    DashboardWidgetType
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model';
import {
    DashboardWidgetObjectDefinition
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model-operator';

export class DashboardWidgetAdditionalLinksModel extends DashboardWidgetModel {
    public static $inject: string[] = DashboardWidgetModel.$inject.concat([]);

    public static dashboardWidgetDefinition: DashboardWidgetObjectDefinition = {
        demoData: {},
        manualAddable: true,
        userPermissions: null,
        widgetDescription: [
            /* translationId */ 'TR_150321-43d463_TR'
        ],
        widgetObject: {
            attribute: {
                id: 'organDashboardWidgetAdditionalLinks',
                width: 2,
                height: 1,
                x: 0,
                y: 0,
                noResize: true,
                autoPosition: true
            },
            componentTagName: 'organ-dashboard-widget-additional-links',
            widgetModel: 'dashboardWidgetAdditionalLinksModel',
            version: '1.0'
        },
        widgetTitle: /* translationId */ 'TR_290121-c4f675_TR',
        widgetType: DashboardWidgetType.custom
    };

    public dashboardWidgetDefinition: DashboardWidgetObjectDefinition;

    constructor() {
        super();

        this.dashboardWidgetDefinition = DashboardWidgetAdditionalLinksModel.dashboardWidgetDefinition;
    }
}
